window.onload = function(e){
    var e = document.getElementsByTagName("img");
    for (var i = 0; i < e.length; i++) {
        if (e[i].hasAttribute('src') && e[i].getAttribute('src') == '//cdn.shopify.com/s/files/1/0475/6461/9930/files/OCD-Home3UpBig-Text-DECK2.jpg?v=1663550850') {
            e[i].setAttribute('loading', 'lazy');
        }
    }
}
